(function () {
    'use strict';

    function booleanSearchField() {
        return {
            restrict: 'E',
            scope: {
                attribute: '=',
                changeEvent: '&'
            },
            templateUrl: 'common/directives/templates/booleanSearchField.html',
            link: function (scope, element, attrs) {
                scope.hasChangeEvent = attrs.changeEvent;
            }
        };
    }

    booleanSearchField.$inject = [];

    angular.module('ecap.common').directive('booleanSearchField', booleanSearchField);
})();